import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminComponent} from '@app/admin/admin/admin.component';
import {AuthGuardService} from '@app/auth/auth-guard.service';

const routes: Routes = [
    { path: 'a', component: AdminComponent, canActivate: [AuthGuardService] },
    { path: 'a/:tab', component: AdminComponent, canActivate: [AuthGuardService] },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AdminRoutingModule {}
